
/**
 * 강의 콘텐츠 지원 플랫폼 환경
 */
export type PlatformSupport = typeof PlatformSupport[keyof typeof PlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
} as const;
